import React, { useEffect, useState } from "react";
import "../payment/thnkpage.css";
import { useLocation } from "react-router-dom";
import { handle_tools_services } from "../../utils/services.js";
import Phonepay_status_api from "./status_Check_api.js";
import { mailforthemeet } from "../../utils/services.js";

import { updateArtTherapyData } from "../../utils/art_therapy.js";
import { sendEmailAPI } from "../../utils/mail_service.js";

const ThankYouStep = () => {
  const location = useLocation();
  const [status, setStatus] = useState(null);
  const [data, setData] = useState({});
  const [emailParams, setEmailParams] = useState({});
  const [polling, setPolling] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email") || "demo@gmail.com";
  const merchantTransactionId = queryParams.get("transactionid");
  const sessionTime = queryParams.get("sessionTime");
  const sessionDate = queryParams.get("sessionDate");
  const name = queryParams.get("name");
  const number = queryParams.get("ContactNo");
  const  d1ata = JSON.parse(sessionStorage.getItem('art_therapy_data'))
 

  // Polling logic
  const startPolling = async () => {
    const intervals = [
      { interval: 20000, duration: 25000 },
      { interval: 3000, duration: 30000 },
      { interval: 6000, duration: 60000 },
      { interval: 10000, duration: 60000 },
      { interval: 30000, duration: 60000 },
      { interval: 60000, duration: 1200000 },
    ];

    for (const { interval, duration } of intervals) {
      let elapsed = 0;
      while (elapsed < duration) {
        const result = await Phonepay_status_api(merchantTransactionId);
        const resultData = result?.data?.responsedata?.data;
        const paymentStatus = result?.data?.responsedata?.code;

        setData(resultData);
        setStatus(paymentStatus);

        if (paymentStatus !== "PAYMENT_PENDING") return;
        elapsed += interval;
        await new Promise((resolve) => setTimeout(resolve, interval));
      }
    }
  };

  // Fetch status on every load
  useEffect(() => {
    if (!merchantTransactionId) return;

    // Removed hasLoaded check to make it run every time
    Phonepay_status_api(merchantTransactionId)
      .then((result) => {
        const resultData = result?.data?.responsedata?.data;
        const paymentStatus = result?.data?.responsedata?.code;
       
        setData(resultData);
        setStatus(paymentStatus);

        if (paymentStatus === "PAYMENT_PENDING" && !polling) {
          setPolling(true);
          startPolling();
        }

        const paymentData = {
          ...resultData?.paymentInstrument,
          amount: resultData?.amount / 100,
          merchantId: resultData?.merchantId,
          merchantTransactionId: resultData?.merchantTransactionId,
          transactionId: resultData?.transactionId,
          email,
          name,
          number,
        };

        setEmailParams({
          email,
          sessionTime,
          sessionDate,
          data: paymentData,
        });
      })
      .catch((error) => {
        setStatus("PAYMENT_ERROR");
      });
  }, [merchantTransactionId]);

  // Send data to DB/email on success
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (status === "PAYMENT_PENDING") {
        event.preventDefault();
        event.returnValue =
          "Payment is still processing. Are you sure you want to leave?";
      }
    };

    if (status === "PAYMENT_SUCCESS") {
      // const storedData = sessionStorage.getItem("bookingDataForEmail");

      // if (storedData) {
      //   const bookingData = JSON.parse(storedData);
      //   console.log(bookingData);
      //   console.log(
      //     "Payment successful, sending final confirmation email with:",
      //     bookingData
      //   );

      //   // Call the email service with the retrieved data
      //   mailforthemeet(bookingData);

      //   // Clean up by removing the item from storage
      //   sessionStorage.removeItem("bookingDataForEmail");
      // }
        const artTherapyData = sessionStorage.getItem('art_therapy_data');
      
      if (artTherapyData) {


        try {
          const parsedData = JSON.parse(artTherapyData);

          
          console.log(parsedData)
          // Update the art therapy data via API
          const updateData = async (data) => {
            try {
              await updateArtTherapyData(data.Id, data);
              console.log('Art therapy data updated and removed from localStorage');
            } catch (error) {
              console.error('Error updating art therapy data:', error);
            }
          };

          const send_confirmation_mail = async(data)=>{
try {
               const subject = '🎟️ Your Ticket to Mento’s Expressive Art Workshop 2.0'

              const body =`<html>
  <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
    <p>Hi <strong>${parsedData.name}</strong>,</p>

    <p>Thank you for registering for <strong>Mento’s Expressive Art Workshop 2.0  💙</strong><br>
    We’re excited to have you join us for an evening of creativity, healing, and new connections.</p>

    <h3>📍 Event Details</h3>
    <p>
      <strong>Date:</strong> 6th of December 2025<br>
      <strong>Day:</strong> Saturday<br>
      <strong>Time:</strong> 3:00pm - 5:00pm<br>
      <strong>Venue:</strong> The Artist House, Surajpole, Udaipur
    </p>

    <h3>🔑 Your Registration Details</h3>
    <p>
      <strong>Name:</strong> ${parsedData.name}<br>
      <strong>Phone:</strong> ${parsedData.contactno}<br>
      <strong>Registration ID:</strong> ${parsedData.Id}
    </p>

    <p>💡 This email is your official e-ticket. Please show it at the Venue (on your phone or printed).</p>

    <h3>✨ What to expect:</h3>
    <ul>
      <li>A safe, welcoming space 🌿</li>
      <li>Creative expression through art 🎨</li>
      <li>Refreshments on us ☕</li>
      <li>New connections with like-minded people 🤝</li>
    </ul>

    <p>We can’t wait to see you there!</p>

    <p>Warmly,<br>
    Team Mento</p>
  </body>
</html>
`


const mento_sub = 'New registration payment has been submitted'

const organizerMailBody = `
<html>
  <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
    <h2>Hello Team Mento,</h2>

    <p>A new participant has registered for the <strong>Expressive Art Workshop 2.0  🎉</strong></p>

    <h3>📍 Registration Details:</h3>
    <table style="border-collapse: collapse; width: 100%; max-width: 600px;">
      <tr>
        <td style="padding: 8px; border: 1px solid #ddd;"><strong>Name</strong></td>
        <td style="padding: 8px; border: 1px solid #ddd;">${parsedData.name}</td>
      </tr>
      <tr>
        <td style="padding: 8px; border: 1px solid #ddd;"><strong>Email</strong></td>
        <td style="padding: 8px; border: 1px solid #ddd;">${parsedData.email}</td>
      </tr>
      <tr>
        <td style="padding: 8px; border: 1px solid #ddd;"><strong>Phone</strong></td>
        <td style="padding: 8px; border: 1px solid #ddd;">${parsedData.contactno}</td>
      </tr>
      <tr>
        <td style="padding: 8px; border: 1px solid #ddd;"><strong>Registration ID</strong></td>
        <td style="padding: 8px; border: 1px solid #ddd;">${parsedData.Id}</td>
      </tr>
      <tr>
        <td style="padding: 8px; border: 1px solid #ddd;"><strong>Pass Selected</strong></td>
        <td style="padding: 8px; border: 1px solid #ddd;">${parsedData.type}</td>
      </tr>
      <tr>
        <td style="padding: 8px; border: 1px solid #ddd;"><strong>Amount</strong></td>
        <td style="padding: 8px; border: 1px solid #ddd;">${parsedData.amount}</td>
      </tr>
      <tr>
        <td style="padding: 8px; border: 1px solid #ddd;"><strong>Payment Status</strong></td>
        <td style="padding: 8px; border: 1px solid #ddd;">${parsedData.paymentStatus || "Not Paid"}</td>
      </tr>
    </table>

    <h3>📅 Event Details:</h3>
    <p>
      <strong>Date:</strong> 6th of December 2025<br>
      <strong>Day:</strong> Saturday<br>
      <strong>Time:</strong> 3:00pm - 5:00pm<br>
      <strong>Venue:</strong> The Artist House, Surajpole, Udaipur
    </p>

    <p style="color: #555; font-size: 14px;">
      This is an auto-generated confirmation for internal records.<br>
      Please keep this for tracking attendance and payments.
    </p>

    <p>Best,<br>
    <em>Your Registration System 🧾</em></p>
  </body>
</html>
`;





            const res=  await sendEmailAPI('send_mail',data.email,subject,body)
            const mentores = await sendEmailAPI('send_mail',process.env.REACT_APP_EMAIL,mento_sub,organizerMailBody)

            if(res.success){
              console.log('mail send successfully')
              console.log('Art therapy data updated and removed from localStorage');
            }
            } catch (error) {
              console.error('Error updating art therapy data:', error);
            }


          }
          
          updateData(parsedData);
          send_confirmation_mail(parsedData);


        } catch (error) {
          console.error('Error parsing art therapy data from localStorage:', error);
        }
      } else {
        console.log('No art therapy data found in localStorage');
      }
      
      handle_tools_services(emailParams.data, "payment");

     
      // mail confirmation goes here
    }

    if (status === "PAYMENT_PENDING") {
      window.addEventListener("beforeunload", handleBeforeUnload);
    }

    if (status === "PAYMENT_CANCELLED") {
      const storedData = sessionStorage.getItem("bookingDataForEmail");
     
      // if (storedData) {
      //   const bookingData = JSON.parse(storedData);
      //   console.log(bookingData);
      //   console.log(
      //     "Payment successful, sending final confirmation email with:",
      //     bookingData
      //   );

      //   // Call the email service with the retrieved data
      //   mailforthemeet(bookingData);

      //   // Clean up by removing the item from storage
      //   sessionStorage.removeItem("bookingDataForEmail");
      // }
    }
    if(status === 'PAYMENT_ERROR'){
     
    }



    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [status]);

  // Render logic
  const renderSuccessPage = () => (
    <div className="form-step-MN form-step-8-MN">
      <div className="thank-you-MN">
        <div className="check-icon-MN">✓</div>
        <h2 className="form-thankyou-title">Thank You!</h2>
        <p className="form-subtitle-MN">
          Your Payment is received Successfully
        </p>
        <div className="confirmation-details-MN">
          <p>
            We've received your payment, and our team will reach out shortly.
          </p>
          <p>
            We've sent a confirmation email to: <strong>{email}</strong>
          </p>
        </div>
        <div className="contact-info-MN">
          <p>If you have any questions, contact us at:</p>
          <p>
            <strong>connectmento@gmail.com</strong> or{" "}
            <button
              onClick={() =>
                (window.location.href = "https://wa.me/9120719120")
              }
            >
              WhatsApp Us
            </button>
          </p>
        </div>
      </div>
    </div>
  );

  const renderFailedPage = () => (
    <div className="form-step-MN form-step-8-MN">
      <div className="payment-failed-MN">
        <div className="error-icon-MN">✕</div>
        <h2 className="form-thankyou-title">Payment Failed</h2>
        <p className="form-subtitle-MN">
          We couldn't process your payment. Please try again.
        </p>
        <ul>
          <li>Insufficient funds</li>
          <li>Incorrect card details</li>
          <li>Transaction declined by your bank</li>
          <li>Network or connectivity issues</li>
        </ul>
        <button onClick={() => (window.location.href = "/contact")}>
          Contact Support
        </button>
      </div>
    </div>
  );

  const renderPendingPage = () => (
    <div className="form-step-MN form-step-8-MN">
      <div className="payment-pending-MN">
        <div className="pending-icon-MN">⟳</div>
        <h2 className="form-thankyou-title">Payment Processing</h2>
        <p className="form-subtitle-MN">
          Your payment is being processed. Please wait.
        </p>
        <p>
          Confirmation email will be sent to <strong>{email}</strong>
        </p>
      </div>
    </div>
  );

  const renderCancelledPage = () => (
    <div className="form-step-MN form-step-8-MN">
      <div className="payment-cancelled-MN">
        <div className="cancelled-icon-MN">❎</div>
        <h2 className="form-thankyou-title">Payment Cancelled</h2>
        <p className="form-subtitle-MN">Your payment process was cancelled.</p>
      </div>
    </div>
  );

  const renderDeclinedPage = () => (
    <div className="form-step-MN form-step-8-MN">
      <div className="payment-declined-MN">
        <div className="declined-icon-MN">🚫</div>
        <h2 className="form-thankyou-title">Payment Declined</h2>
        <p className="form-subtitle-MN">
          Your payment was declined by your bank or financial institution.
        </p>
      </div>
    </div>
  );

  const renderIncompletePaymentPage = () => (
    <div className="form-step-MN form-step-8-MN">
      <div className="payment-incomplete-MN">
        <div className="cancelled-icon-MN">❎</div>
        <h2 className="form-thankyou-title">Payment Not Completed</h2>
        <p className="form-subtitle-MN">
          It looks like the payment process was not completed.
        </p>
        <p>You can try again, or contact our support team if you need help.</p>
        <button onClick={() => (window.location.href = "/contact")}>
          Contact Support
        </button>
      </div>
    </div>
  );

  if (!status)
    return <div className="form-step-MN">Loading payment status...</div>;

  switch (status) {
    case "PAYMENT_SUCCESS":
         // Your existing sessionStorage reading and email logic here
      const storedData = sessionStorage.getItem("bookingDataForEmail");

      if (storedData) {
        const bookingData = JSON.parse(storedData);
        // console.log(bookingData);
        // console.log(
        //   "Payment error occurred, but sending final confirmation email with:",
        //   bookingData
        // );

        mailforthemeet(bookingData);

        sessionStorage.removeItem("bookingDataForEmail");
      }
      return renderSuccessPage();
    case "PAYMENT_PENDING":
      return renderPendingPage();
    case "PAYMENT_ERROR":
       
      
      sessionStorage.removeItem("bookingDataForEmail");
      sessionStorage.removeItem("bookingDataForEmail");
      return renderFailedPage();
    case "PAYMENT_CANCELLED":
    
      return renderCancelledPage();
    case "PAYMENT_DECLINED":
      sessionStorage.removeItem("bookingDataForEmail");
      return renderDeclinedPage();
    case "TRANSACTION_NOT_FOUND":
      return renderIncompletePaymentPage();
    default:
      return renderPendingPage();
  }
};

export default ThankYouStep;
